<script lang="ts">
  import * as Breadcrumb from "$lib/components/ui/breadcrumb/index.js";
  import { StringUtils } from "$lib/stringUtils";
  import { onMount } from "svelte";
  import { params, location } from "svelte-spa-router";
  import BreadcrumbCustomer from "./breadcrumb-customer.svelte";
  import BreadcrumbProject from "./breadcrumb-project.svelte";
  import { CircleArrowLeft } from "lucide-svelte";
  import { t } from "svelte-i18n";
  import { Button } from "$lib/components/ui/button";
  import { isEditActive } from "$src/application/main/mainTemplateStore";

  export let groupStoreId: number;

  let projectId: number | null;
  let customerId: number | null;

  onMount(() => extractParams($params));
  $: extractParams($params);
  function extractParams(parameters?: Record<string, string>) {
    customerId = null;
    projectId = null;

    if (parameters?.projectId) {
      projectId = StringUtils.getNumberOrDefault(parameters.projectId, 0);
    } else if (parameters?.customerId) {
      customerId = StringUtils.getNumberOrDefault(parameters.customerId, 0);
    }
  }

  function goBack() {
    window.history.back();
  }
</script>

{#if customerId || projectId}
  <Breadcrumb.Root class="hidden md:flex">
    <Breadcrumb.List class="gap-1">
      <Breadcrumb.Item class="hidden sm:flex">
        <Breadcrumb.Link href={`#/gs/${groupStoreId}/projects`} asChild={$isEditActive}>
          {$t("global.breadcrumb.projects")}
        </Breadcrumb.Link>
      </Breadcrumb.Item>
      {#if customerId}
        <BreadcrumbCustomer {groupStoreId} {customerId} />
      {:else if projectId}
        <BreadcrumbProject {groupStoreId} {projectId} />
      {/if}
    </Breadcrumb.List>
  </Breadcrumb.Root>
  <div class="flex md:hidden">
    <Button variant="link" on:click={goBack} disabled={$isEditActive}>
      <CircleArrowLeft />
    </Button>
  </div>
{/if}
